var ErrorStorageProperties = /* @__PURE__ */ ((ErrorStorageProperties2) => {
  ErrorStorageProperties2["expErrorIssue"] = "expErrorIssue";
  ErrorStorageProperties2["expErrorDescription"] = "expErrorDescription";
  ErrorStorageProperties2["expErrorClientRequestId"] = "expErrorClientRequestId";
  return ErrorStorageProperties2;
})(ErrorStorageProperties || {});
var ApiErrorType = /* @__PURE__ */ ((ApiErrorType2) => {
  ApiErrorType2["SystemRetryableError"] = "SystemRetryableError";
  ApiErrorType2["UserError"] = "UserError";
  ApiErrorType2["TimeoutOrCancelledError"] = "TimeoutOrCancelledError";
  ApiErrorType2["UnknownError"] = "UnknownError";
  ApiErrorType2["MovedPermanently"] = "MovedPermanently";
  return ApiErrorType2;
})(ApiErrorType || {});
var ReadyStateErrorType = /* @__PURE__ */ ((ReadyStateErrorType2) => {
  ReadyStateErrorType2["UNSENT"] = "UNSENT";
  ReadyStateErrorType2["OPENED"] = "OPENED";
  ReadyStateErrorType2["HEADERS_RECEIVED"] = "HEADERS_RECEIVED";
  ReadyStateErrorType2["LOADING"] = "LOADING";
  ReadyStateErrorType2["DONE"] = "DONE";
  return ReadyStateErrorType2;
})(ReadyStateErrorType || {});
var ReadyStateErrorDescription = /* @__PURE__ */ ((ReadyStateErrorDescription2) => {
  ReadyStateErrorDescription2["UNSENT"] = "Client has been created. open() not called yet.";
  ReadyStateErrorDescription2["OPENED"] = "open() has been called.";
  ReadyStateErrorDescription2["HEADERS_RECEIVED"] = "send() has been called, and headers and status are available.";
  ReadyStateErrorDescription2["LOADING"] = "Downloading; responseText holds partial data.";
  ReadyStateErrorDescription2["DONE"] = "The operation is complete.";
  return ReadyStateErrorDescription2;
})(ReadyStateErrorDescription || {});
export {
  ApiErrorType,
  ErrorStorageProperties,
  ReadyStateErrorDescription,
  ReadyStateErrorType
};
//# sourceMappingURL=ErrorModels.js.map
